import { graphql, useFragment } from "react-relay";

import moment from "moment";

import type { useEventState_stream$key } from "~/__generated__/useEventState_stream.graphql";

export type EventState = "no_event" | "expired" | "has_upcoming" | "expiring" | "invalid";

const eventStateFragment = graphql`
	fragment useEventState_stream on NoteStream {
		linkedEventGuid
		linkedEvent {
			nextOccurrence {
				start
				end
			}
			finalOccurrence
		}
	}
`;

export function useEventState(eventInfo: useEventState_stream$key): EventState {
	const { linkedEvent, linkedEventGuid } = useFragment(eventStateFragment, eventInfo);

	if (linkedEventGuid != null && linkedEvent == null) return "invalid";
	if (linkedEvent == null) return "no_event";
	const { finalOccurrence, nextOccurrence } = linkedEvent;

	if (finalOccurrence && moment(finalOccurrence).isBefore(moment())) {
		return "expired";
	} else if (finalOccurrence && moment(finalOccurrence).isBefore(moment().add(7, "days"))) {
		return "expiring";
	} else if (nextOccurrence) {
		return "has_upcoming";
	}
	return "no_event";
}
